import React, { useState, useEffect } from "react";
import { getUserFromStorage, isAuthenticatedUser } from "../../../utils/Auth";
//components
import Container from "../../../components/container/container";
// import Collapse from "../../../components/cards/faqCollapse";
//images and icons
import Banner from "../../../assets/images/pictures/help-banner.jpg";
import BannerDark from "../../../assets/images/pictures/help-banner-dark.png";


const tabs = [
  { name: "GENERAL QUESTIONS", href: "general" },
  { name: "VIDEO GUIDE", href: "video" },
];

const videos = [
  {
    video_id: "1GCoQkWXzKdNnrRrdU0hh2ZF0vU1fzg_k",
    title: "How to register on Ogwugo",
    time: "0:57",
  },
  {
    video_id: "1vsHd3YDI40gXXKjXKHP1w0s80bAU97eT",
    title: "How to create a business on Ogwugo ",
    time: "1:59",
  },
  {
    video_id: "1xuUCfHqbXJL97m-_fMCXA4ckuQSes66J",
    title: "How to create a merchandise",
    time: "1:22",
  },
  {
    video_id: "14gxZn6uOz9upDgqdOHrTE5CcrcSYZK7W",
    title: "How to create a manage your store settings",
    time: "1:28",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


export default function Faq() {

  const user = getUserFromStorage();
  const isAuth = isAuthenticatedUser();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [active_tab, setActive_tab] = useState("general");

  useEffect(() => {
    if (document.documentElement.classList.contains("dark")) {
      setIsDarkMode(true);
    }
  }, []);

  const toggle = (tab) => {
    setActive_tab(tab.href);
  };
  return (
    <div data-test="help-page">
      <div
        className="min-h-96 bg-cover no-repeat bg-center relative z-0"
        style={{
          backgroundImage: `url('${isDarkMode ? BannerDark : Banner}')`,
        }}
      >
        <Container>
          <div className="py-14">
            <div className="py-2 max-w-lg px-6 mx-auto relative">
              <div className="absolute left-0 top-0 h-full border-l-4 border-primary"></div>

              {/* <!-- Right border --> */}
              <div className="absolute right-0 top-0 h-full border-r-4 border-primary"></div>

              {/* <!-- Top left --> */}
              <div className="absolute top-0 left-0 w-12 border-t-4 border-primary"></div>

              {/* <!-- Top right --> */}
              <div className="absolute top-0 right-0 w-12 border-t-4 border-primary"></div>

              {/* <!-- Bottom left --> */}
              <div className="absolute bottom-0 left-0 w-12 border-b-4 border-primary"></div>

              {/* <!-- Bottom right --> */}
              <div className="absolute bottom-0 right-0 w-12 border-b-4 border-primary"></div>
              <h2
                className="text-2xl text-center font-medium mb-5 mt-10"
                style={{ lineHeight: "32px" }}
              >
                Hi {isAuth ? user?.name : ""}, you've got questions? We have
                answers
              </h2>
            </div>
          </div>
        </Container>
      </div>

      <Container>
        <main className="py-8">
          <div className="max-w-3xl mx-auto lg:max-w-7xl">
            <h1 className="sr-only">Faq Page</h1>

            <nav
              className="-mb-px flex space-x-8 overflow-x-auto sm:max-w-[850px] mx-auto w-full mb-16 mt-6"
              aria-label="Tabs"
            >
              {tabs.map((tab) => (
                <button
                  key={tab.href}
                  onClick={() => {
                    toggle(tab);
                  }}
                  className={classNames(
                    tab.href === active_tab
                      ? "border-primary text-primary font-bold bg-[#FFEAE5]"
                      : "border-transparent text-[#333333] dark:text-[#BCBCBC] hover:text-gray-700",
                    "whitespace-nowrap py-3 px-4 border-2 font-medium text-sm rounded-md hover:bg-primary hover:text-white"
                  )}
                  aria-current={
                    tab.id === active_tab ? "page" : undefined
                  }
                >
                  {tab.name}
                </button>
              ))}
            </nav>

            {active_tab === 'video' &&
              <section
                aria-labelledby="video-tutorial-section"
                className="mt-5 mb-16"
              >
                <h3 className="text-xl font-bold mb-5">Quick Start Tutorial</h3>
                <div className="grid sm:grid-cols-3 gap-5 sm:gap-5">
                  {videos?.length > 0 &&
                    videos.map((video, index) => (
                      <div key={index}>
                        <div

                          style={{ position: "relative", paddingTop: "56.25%" }}
                        >
                          <iframe
                            src={`https://drive.google.com/file/d/${video?.video_id}/preview`}
                            width="100%"
                            height="100%"
                            style={{ position: "absolute", top: 0, left: 0 }}
                            allow="autoplay"
                            allowFullScreen
                            title={video?.title}
                          />
                        </div>
                        <div className="mt-3">
                          <p>{video?.title}</p>
                          <p>{video?.time} secs</p>
                        </div>
                      </div>
                    ))}
                </div>
              </section>
            }

            {active_tab === 'general' &&
              <section aria-labelledby="section-1-title">
                {/* Your content */}

                <div className="mt-10">
                  <p className="mb-6 text-xl">
                    <span className="font-bold">Ogwugo</span> is an online marketplace and delivery platform that lets you order food, groceries, and other everyday items from nearby vendors and stores. You can shop from the comfort of your home and have your order delivered straight to your doorstep.
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 divide-x-0 md:divide-x-4 divide-gray-300 dark:divide-gray-600 sm:border-b-4 border-gray-300 dark:border-gray-600">
                    <div className="md:pr-8">
                      <p className="mb-4 font-semibold">Signing up is easy and quick:</p>
                      <ol className="mb-4 list-decimal list-inside space-y-2 ml-2">
                        <li>Visit the website or download the app</li>
                        <li>Click on Sign Up</li>
                        <li>Enter your name, phone number, and email</li>
                        <li>Verify your details</li>
                      </ol>
                      <p>Once you're done, you can start browsing and placing orders immediately</p>
                    </div>

                    <div className="md:pl-8 pt-8 md:pt-0">
                      <p className="mb-4 font-semibold">Ogwugo currently operates in:</p>
                      <ol className="mb-4 list-decimal list-inside space-y-2 ml-2">
                        <li>Enugu</li>
                        <li>Nsukka</li>
                        <li>Surrounding areas</li>
                      </ol>
                      <p className="mb-4">We are working to expand to more cities across Nigeria.</p>
                      <p className="mb-4">For non-food items, delivery may be available across wider regions.</p>
                    </div>
                  </div>

                  <div className="mt-16">
                    <h2 className="text-2xl font-bold mb-6">Ordering and Delivery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 divide-x-0 md:divide-x-4 divide-gray-300 dark:divide-gray-600 sm:border-b-4 border-gray-300 dark:border-gray-600">
                      <div className="md:pr-8 pb-4">
                        <h3 className="font-semibold text-lg mb-3">How do I place an order?</h3>
                        <ol className="mb-6 list-decimal list-inside space-y-2 ml-2">
                          <li>Browse available vendors or products</li>
                          <li>Select your preferred items</li>
                          <li>Add to cart</li>
                          <li>Proceed to checkout</li>
                          <li>Choose your payment method</li>
                          <li>Confirm your order</li>
                        </ol>
                        <h3 className="font-semibold text-lg mb-3">How do I know a store is available?</h3>
                        <p className="mb-3">Stores shown on the platform are expected to be open and available.</p>
                        <p className="mb-6">However, if a store becomes unavailable after you place an order, our team will notify you and provide alternative options or a resolution.</p>
                        <h3 className="font-semibold text-lg mb-3">How long does delivery take?</h3>
                        <p className="mb-3">Delivery time depends on:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>Your location</li>
                          <li>Vendor preparation time</li>
                          <li>Traffic conditions</li>
                        </ol>
                        <p>The estimated delivery time will be shown during checkout, where available.</p>
                      </div>
                      <div className="md:pl-8 pt-8 md:pt-0">
                        <h3 className="font-semibold text-lg mb-3">Can I track my order?</h3>
                        <p className="mb-3">Yes. You will receive updates on your order status after placing it. You can find this option when you click on "My Orders."</p>
                        <p className="mb-6">We are continuously improving our tracking system to provide more accurate, real-time updates.</p>
                        <h3 className="font-semibold text-lg mb-3">What happens if my order cannot be fulfilled?</h3>
                        <p className="mb-3">If your order cannot be completed (for example, if a store is unavailable), we will:</p>
                        <ol className="mb-6 list-decimal list-inside space-y-2 ml-2">
                          <li>Notify you immediately</li>
                          <li>Suggest alternative vendors where possible</li>
                          <li>Assist you with a resolution, including a refund if applicable</li>
                        </ol>
                        <h3 className="font-semibold text-lg mb-3">How long does it take to get a refund?</h3>
                        <p>Refunds are processed within 24 business hours, depending on your payment method. Our team will guide you through the process if a refund is required.</p>
                      </div>
                    </div>
                  </div>


                  <div className="mt-16">
                    <h2 className="text-2xl font-bold mb-6">For Vendors and Partners</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 divide-x-0 md:divide-x-4 divide-gray-300 dark:divide-gray-600 sm:border-b-4 border-gray-300 dark:border-gray-600">
                      <div className="md:pr-8">
                        <h3 className="font-semibold text-lg mb-3">How can I become a vendor on Ogwugo?</h3>
                        <p className="mb-3">To sell on Ogwugo:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>Visit the website</li>
                          <li>Click on Create a Business</li>
                          <li>Fill out the registration form</li>
                          <li>Wait for approval</li>
                        </ol>
                        <p className="mb-6">Once approved, you can list your products and start receiving orders.</p>
                        <h3 className="font-semibold text-lg mb-3">What items can I sell on Ogwugo?</h3>
                        <p className="mb-3">You can sell a wide range of items, including:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>Food and meals</li>
                          <li>Groceries</li>
                          <li>Electronics</li>
                          <li>Household items</li>
                          <li>Other approved products</li>
                        </ol>
                      </div>
                      <div className="md:pl-8 pt-8 md:pt-0">
                        <h3 className="font-semibold text-lg mb-3">How do I manage my store?</h3>
                        <p className="mb-3">After registration, you can:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>Add products</li>
                          <li>Update prices</li>
                          <li>Manage orders</li>
                          <li>Adjust store settings</li>
                        </ol>
                        <p>Tutorial videos are available on the help page to guide you.</p>
                      </div>
                    </div>
                  </div>


                  <div className="mt-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 divide-x-0 md:divide-x-4 divide-gray-300 dark:divide-gray-600">
                      <div className="md:pr-8">
                        <h2 className="text-2xl font-bold mb-6">Delivery Partners (O-Pilots)</h2>
                        <p className="mb-3">To join as a delivery partner:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>Visit the O-Pilot section on the website</li>
                          <li>Click Sign Up</li>
                          <li>Fill in your details</li>
                        </ol>
                        <p className="mb-6">You can also contact support for more information.</p>
                        <h3 className="font-semibold text-lg mb-3">Do you accept third-party riders?</h3>
                        <p>Yes, we accept third-party delivery agents. You can apply by contacting our support team.</p>
                      </div>
                      <div className="md:pl-8 pt-8 md:pt-0">
                        <h2 className="text-2xl font-bold mb-6">Support</h2>
                        <h3 className="font-semibold text-lg mb-3">How do I contact customer support?</h3>
                        <p className="mb-3">You can reach our support team through:</p>
                        <ol className="mb-3 list-decimal list-inside space-y-2 ml-2">
                          <li>In-app support</li>
                          <li>Website contact options</li>
                          <li>Email or phone</li>
                        </ol>
                        <p>We are here to help resolve any issues as quickly as possible.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            }
          </div>
        </main>
      </Container>
    </div>
  );
}
